import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, map, Observable, of, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';

/** App-ID eines Users für die Anmeldung am Tablet (Id_App) */
@Injectable({
  providedIn: 'root',
})
export class UserAppIdService {
  private http = inject(HttpClient);

  private url(userId: number): string {
    return `${environment.apiUrl}/users/${userId}/app-id`;
  }

  /** null, wenn der User keine App-ID hat (404) */
  getAppId(userId: number): Observable<number | null> {
    return this.http.get<{ appId: number }>(this.url(userId)).pipe(
      map((dto) => dto.appId),
      catchError((e: HttpErrorResponse) =>
        e.status === 404 ? of(null) : throwError(() => e),
      ),
    );
  }

  /** 409, wenn die App-ID schon vergeben ist */
  setAppId(userId: number, appId: number): Observable<{ appId: number }> {
    return this.http.put<{ appId: number }>(this.url(userId), { appId });
  }

  deleteAppId(userId: number): Observable<void> {
    return this.http.delete<void>(this.url(userId));
  }

  /** Summe aller Check-ins am Tablet (Abmeldung − Anmeldung); wie Spalte "Stunden" im Report */
  getOnSiteHours(userId: number): Observable<number> {
    return this.http
      .get<{ totalHours: number }>(`${environment.apiUrl}/users/${userId}/on-site-hours`)
      .pipe(map((dto) => dto.totalHours));
  }
}
